module.exports = __webpack_public_path__ + "components/home-header/static/header-5--medium-2c52ef615ece0c71be260d46a760ddb4.jpg";